import React from 'react'
import { Icon } from '@pff-consumer/web-ui/components/icon/icon'
import { checkoutHooks } from '@pff-consumer/data-provider/lib/checkout/checkout.hooks'
import { SVGGroup } from '@pff-consumer/utils/lib/svg/svg-group'
import { FeatureCardProps } from './feature-card.props'
import { useStyles } from './feature-card.styles'

const { useBreakpoints } = checkoutHooks

export const FeatureCard = (props: FeatureCardProps) => {
  const { imagePath, imageAltText, title, subTitle, featurePoints } = props
  const { isDesktop } = useBreakpoints()
  const styles = useStyles({ ...props, isDesktop })

  return (
    <div className={styles.containerCard}>
      <picture>
        <img
          src={imagePath}
          alt={imageAltText}
          className={styles.image}
        />
      </picture>
      <div className={styles.title}>{title}</div>
      <div className={styles.subTitle}>{subTitle}</div>
      <div className={styles.cardFeatureContainer}>
        {featurePoints.map((point, i) => {
          return (
            <div
              key={`point-${i + 1}`}
              className={styles.feature}
            >
              <Icon
                name='checkmark-green'
                testID='feature-point-icon'
                group={SVGGroup.Icons}
                width={12}
                height={12}
              />
              <span className={styles.featureText}>{point}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
